import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { Button } from './ui/button';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section id="testemunhos" className="py-20 bg-gradient-to-br from-[#071028] to-[#0077C8]/20 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#1FA2FF]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#0077C8]/10 rounded-full blur-3xl"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            O Que Dizem os Nossos Clientes
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star key={star} className="w-6 h-6 text-[#1FA2FF] fill-[#1FA2FF]" />
            ))}
          </div>
          <p className="text-lg text-gray-300">
            Avaliação média: 4.9/5 baseada em mais de 100 avaliações
          </p>
        </div>

        {/* Testimonial Card */}
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 sm:p-12 mb-8">
          {/* Stars */}
          <div className="flex justify-center gap-1 mb-6">
            {[...Array(currentTestimonial.rating)].map((_, i) => (
              <Star key={i} className="w-5 h-5 text-[#1FA2FF] fill-[#1FA2FF]" />
            ))}
          </div>

          {/* Quote */}
          <blockquote className="text-xl sm:text-2xl text-white text-center leading-relaxed mb-8 italic">
            “{currentTestimonial.text}”
          </blockquote>

          {/* Author */}
          <div className="text-center">
            <p className="text-lg font-bold text-white">{currentTestimonial.name}</p>
            <p className="text-[#1FA2FF]">{currentTestimonial.location}</p>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4">
          <Button
            onClick={prevTestimonial}
            variant="outline"
            size="icon"
            className="border-white/30 text-white hover:bg-white/20 hover:border-white rounded-full w-12 h-12 transition-all duration-300"
          >
            <ChevronLeft className="w-6 h-6" />
          </Button>

          {/* Dots */}
          <div className="flex gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-[#1FA2FF] w-8'
                    : 'bg-white/30 hover:bg-white/50'
                }`}
              />
            ))}
          </div>

          <Button
            onClick={nextTestimonial}
            variant="outline"
            size="icon"
            className="border-white/30 text-white hover:bg-white/20 hover:border-white rounded-full w-12 h-12 transition-all duration-300"
          >
            <ChevronRight className="w-6 h-6" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
